import { render } from "./ModalDialog.vue?vue&type=template&id=e5f04de6&scoped=true&ts=true"
import script from "./ModalDialog.vue?vue&type=script&lang=ts"
export * from "./ModalDialog.vue?vue&type=script&lang=ts"

import "./ModalDialog.vue?vue&type=style&index=0&id=e5f04de6&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f04de6"]])

export default __exports__